import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col, Container, Row, Table
} from "reactstrap";
import styles from "./style.module.scss";
import cx from "classnames";
import { errorHandler } from "utils/Api";
import { getPackages } from "api/PackagesApi";
import { IN_COSTA_RICA_STATUS, IN_MIAMI_STATUS, IN_TRANSIT_STATUS } from "utils/Constants";
import AdminPackagesTable from "components/AdminPackagesTable";
import NewUserPOBoxes from "components/NewUserPOBoxes";

const AdminDashboard = props => {
  const [packagesStatus, setPackagesStatus] = useState({});
  const [packagesList, setPackagesList] = useState({});
  const [isPackageListVisible, setIsPackageListVisible] = useState(false);
  const [packagesFilterType, setPackagesFilterType] = useState("");

  useEffect(() => {
    fetchUserPackages();
  }, []);

  const fetchUserPackages = async () => {
    const filter = {
      isDelivered: { eq: false }
    };

    const status = {
      preOrders: 0,
      inMiami: 0,
      inTransit: 0,
      inCostaRica: 0,
    }
    try {
      const { items: packages } = await getPackages({ filter, limit: 500 });
      const groupedPackages = packages.reduce((a, p) => {
        if (!p.received) {
          a.preOrders++;
        } else if (!p.cargoMovement ||
          (p.cargoMovement && IN_MIAMI_STATUS.includes(p.cargoMovement.status))
        ) {
          a.inMiami++;
        } else {
          const cargoMovement = p.cargoMovement;
          if (IN_TRANSIT_STATUS.includes(cargoMovement.status)) {
            a.inTransit++
          } else if (IN_COSTA_RICA_STATUS.includes(cargoMovement.status)) {
            a.inCostaRica++
          }
        }
        return a;
      }, status);
      setPackagesStatus(groupedPackages);
      setPackagesList(packages);

    } catch (e) {
      errorHandler(e)
    }
  }

  const viewPackages = (packageType) => {
    setPackagesFilterType(packageType);
    setIsPackageListVisible(true);
  }


  return (
    <>
      <Container fluid={true} className={cx([styles.mainContainer])}>
        <Row>
          <Col>
            <NewUserPOBoxes />
          </Col>
        </Row>
        <Row>
          <Col lg={3}>
            <Card>
              <CardBody>
                <CardTitle tag="h5">
                  Movimiento de Paquetes
                </CardTitle>
                <CardText>
                  <Table>
                    <tbody>
                      <tr>
                        <td>Pre-Alertados</td>
                        <td>{packagesStatus.preOrders}</td>
                        <td><Button className="ms-2" size="sm" color="primary" onClick={(e) => { viewPackages("preOrders") }}>
                          Ver
                        </Button>
                        </td>
                      </tr>
                      <tr>
                        <td>En Miami</td>
                        <td>{packagesStatus.inMiami}</td>
                        <td><Button className="ms-2" size="sm" color="primary" onClick={(e) => { viewPackages("inMiami") }}>
                          Ver
                        </Button>
                        </td>
                      </tr>
                      <tr>
                        <td>En Transito</td>
                        <td>{packagesStatus.inTransit}</td>
                        <td><Button className="ms-2" size="sm" color="primary" onClick={(e) => { viewPackages("inTransit") }}>
                          Ver
                        </Button>
                        </td>
                      </tr>
                      <tr>
                        <td>En Costa Rica</td>
                        <td>{packagesStatus.inCostaRica}</td>
                        <td>
                          <Button className="ms-2" size="sm" color="primary" onClick={(e) => { viewPackages("inCostaRica") }}>
                            Ver
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardText>
              </CardBody>
            </Card >
          </Col>
          {isPackageListVisible && (
            <Col>
              <AdminPackagesTable packagesList={packagesList} packagesFilterType={packagesFilterType} />
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
}

export default AdminDashboard;
